import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from "../shared/shared.module";
import { MRLoginComponent } from './mrlogin/mrlogin.component';

const accountRoutes: Routes = [{
    path: 'mrlogin',
    component: MRLoginComponent,
}];

@NgModule({
    imports: [
        FormsModule,
        BrowserModule,
        SharedModule,
        RouterModule.forChild(accountRoutes),
    ],
    declarations: [
        MRLoginComponent
    ],
})
export class MRAccountModule {}
